import { render } from "./SuelasView.vue?vue&type=template&id=c91fb8ce"
import script from "./SuelasView.vue?vue&type=script&lang=js"
export * from "./SuelasView.vue?vue&type=script&lang=js"

import "./SuelasView.vue?vue&type=style&index=0&id=c91fb8ce&lang=css"

import exportComponent from "D:\\laragon\\www\\balkum-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__